// extracted by mini-css-extract-plugin
export default {"cookieContainer":"cookie-banner-module--cookie-container--35PrU","visible":"cookie-banner-module--visible--2L0o8","fadeIn":"cookie-banner-module--fadeIn--KLr5Y"};